<template>
    <div class="navbar navbar-style-1" style="top: unset">
      <div class="navbar-inner">
        <a href="/" @click="toggleMain" class="link back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z"
                fill="black"/>
          </svg>
        </a>
        <div class="title">{{ category['category'].title }}</div>
      </div>
    </div>

    <!-- Page Content -->
    <div class="page-content pt-5">

      <!-- Search backdrop -->
      <div class="searchbar-backdrop"></div>

      <div class="container">
        <!-- Search -->
        <form data-search-container=".search-list" data-search-in=".item-title" id="searchForm"
              class="searchbar searchbar-init search-box list-search-bx">
          <div class="searchbar-inner">
            <div class="searchbar-input-wrap">
              <input type="search" placeholder="Procurar" v-model="search"/>
              <i class="searchbar-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M9.65925 19.3102C11.8044 19.3103 13.8882 18.5946 15.5806 17.2764L21.9653 23.6612C22.4423 24.1218 23.2023 24.1086 23.663 23.6316C24.1123 23.1664 24.1123 22.4288 23.663 21.9636L17.2782 15.5788C20.5491 11.3682 19.7874 5.30335 15.5769 2.03244C11.3663 -1.23846 5.30149 -0.476784 2.03058 3.73376C-1.24033 7.9443 -0.478646 14.0092 3.73189 17.2801C5.42702 18.597 7.51269 19.3113 9.65925 19.3102ZM4.52915 4.52732C7.36245 1.69396 11.9561 1.69391 14.7895 4.52721C17.6229 7.36052 17.6229 11.9542 14.7896 14.7876C11.9563 17.6209 7.36261 17.621 4.52925 14.7877C4.5292 14.7876 4.5292 14.7876 4.52915 14.7876C1.69584 11.9749 1.67915 7.39796 4.49181 4.56465C4.50424 4.55217 4.51667 4.53974 4.52915 4.52732Z"
                      fill="#C9C9C9"/>
                </svg>
              </i>
            </div>
          </div>
        </form>
        <div class="list simple-list searchbar-not-found">
          <ul>
            <li>Sem resultados.</li>
          </ul>
        </div>
      </div>


      <!-- Products -->
      <div class="container">
        <div data-space-between="0" data-slides-per-view="auto" data-centered-slides="false"
             class="swiper swiper-init tabbar tab-style-2">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <a href="#tab-1" class="tab-link tab-link-active">Produtos</a>
            </div>
          </div>
        </div>
      </div>

      <div class="tabs-swipeable-wrap mt-30 tabs-height-auto">
        <div class="tabs">
          <div id="tab-1" class="tab tab-active">
            <div class="list search-list mt-0 mb-20 container searchbar-found item-list">
              <ul class="row" style="gap:0.5em">
                <li class="col-100 medium-50" v-for="item in filteredProducts" :key="item.id">
                  <div class="wishlist-bx" style="box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05)">
                    <div class="dz-info">
                      <div class="dz-head">
                        <div style="display: flex; justify-content: space-between">
                          <h6 class="item-title"><a href="/">{{ item.title }}</a></h6>
                          <div>
                            <img style="width: 24px; height: 24px" :src="`${ allergen }`"
                                 v-for="allergen in item.allergen_image"
                                 :key="allergen.id"/>
                          </div>
                        </div>
                        <ul class="tag-list" style="font-size: 12px; padding: 1%">
                          <!--<li>{{ item.title }}</li>-->
                          <li v-if="item.allergen">
                            <div style="display: flex; align-items: center;">
                              <div style="padding: 2px" v-if="item.allergen && item.allergen.length">
                                Este produto contém: {{ item.allergen.filter(a => a).join(', ') }}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="dz-img">
                        <img :src="getProductImage(item)" alt="Product Image" class="product-img"/>
                      </div>
                      <div class="dz-meta">
                        <ul>
                          <li class="price">{{ item.price }} €</li>
                          <div class="stepper stepper-init stepper-round" :class="{ opacElement: !item.available }"
                               style="border: 1px solid #c4c4c4; height: 42px">
                            <div class="stepper-button-minus" :class="{ disabled: !item.available }" style="border: 0"
                                 @click="removeFromCard(`${ item.id }`)"></div>
                            <div class="stepper-input-wrap" style="border: 0"><input
                                style="font-size: 18px;color: #000;" type="text"
                                :value="itemQuantity(`${ item.id }`)" min="0" max="100"
                                step="1"
                                readonly/>
                            </div>
                            <div class="stepper-button-plus" :class="{ disabled: !item.available }"
                                 @click="addToCart(`${ item.id }`)"
                                 style="border: 0"></div>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <ul style="text-align: center;" v-if="filteredProducts.length === 0">
                <li>Sem resultados.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ProductCategory',
  props: ['category'],
  emits: ['toggle-main', 'toggle-cart'],

  data() {
    return {
      search: '',
      cartUpdated: false,
      cartOpen: false,
    };
  },
  methods: {
    addToCart(id) {
      this.$store.commit('addToCard', this.category['products'].find(i => i.id === id))
    },
    removeFromCard(id) {
      this.$store.commit('removeFromCard', this.category['products'].find(i => i.id === id))
    },
    toggleCart() {
      this.$emit('toggle-cart', true);
    },
    toggleMain() {
      this.$emit('toggle-main', true);
    },
    getProductImage(item){
      if(this.category['category'].title === "Baguetes"){
        if(item.id === "80"){
          return '/assets/img/products/baguetes/baguette branca com fiambre.png'
        }
        if(item.id === "81"){
          return "/assets/img/products/baguetes/baguette branca com queijo.png"
        }
        if(item.id === "82"){
          return "/assets/img/products/baguetes/baguette branca mista.png"
        }
        if(item.id === "83"){
          return "/assets/img/products/baguetes/baguette branca com pasta de atum.png"
        }
        if(item.id === "84"){
          return "/assets/img/products/baguetes/baguette multicereais com pasta de delicias do mar.png"
        }
        if(item.id === "85"){
          return "/assets/img/products/baguetes/baguette multicereais com fiambre.png"
        }
        if(item.id === "86"){
          return "/assets/img/products/baguetes/baguette multicereais com queijo.png"
        }
        if(item.id === "87"){
          return "/assets/img/products/baguetes/baguette multicereais mista.png"
        }
        if(item.id === "88"){
          return "/assets/img/products/baguetes/baguette multicereais com pasta de atum.png"
        }
        if(item.id === "89"){
          return "/assets/img/products/baguetes/baguette branca com pasta de delicias do mar.png"
        }
        if(item.id === "90"){
          return "/assets/img/products/baguetes/baguette sem gluten com queijo.png"
        }
        if(item.id === "91"){
          return "/assets/img/products/baguetes/baguette sem gluten com fiambre.png"
        }
        if(item.id === "92"){
          return "/assets/img/products/baguetes/baguette sem gluten mista.png"
        }
        if(item.id === "93"){
          return "/assets/img/products/baguetes/baguette sem gluten com pasta de atum.png"
        }
        if(item.id === "96"){
          return "/assets/img/products/baguetes/baguette sem gluten com pasta de delicias do mar.png"
        }
      }
      if(this.category['category'].title === "Tostas"){
        if(item.id === "32"){
          return '/assets/img/products/tostas/tosta de fiambre.png'
        }
        if(item.id === "33"){
          return '/assets/img/products/tostas/tosta de queijo.png'
        }
        if(item.id === "34"){
          return '/assets/img/products/tostas/tosta mista.png'
        }
        if(item.id === "35"){
          return '/assets/img/products/tostas/tosta de pasta de atum.png'
        }
        if(item.id === "36"){
          return '/assets/img/products/tostas/tosta de pasta de delicias do mar.png'
        }
      }
      if(this.category['category'].title === "Torradas"){
        if(item.id === "30"){
          return '/assets/img/products/torradas/torrada com compota de abobora.png'
        }
        if(item.id === "31"){
          return '/assets/img/products/torradas/torrada com manteiga.png'
        }
        if(item.id === "130"){
          return '/assets/img/products/torradas/torrada com compota de frutos vermelhos.png'
        }
        if(item.id === "134"){
          return '/assets/img/products/torradas/torrada com creme de barrar de bolachas belgas Lotus Biscoff.png'
        }
      }
      if(this.category['category'].title === "Bolos"){
        if(item.id === "42"){
          return '/assets/img/products/bolos/nata.png'
        }
        if(item.id === "111"){
          return '/assets/img/products/bolos/tarte_maçã.png'
        }
      }
      if(this.category['category'].title === "Bebidas Quentes"){
        if(item.id === '1' || item.id === '3' ||item.id === '4'|| item.id === '107' || item.id === '109'){
          return '/assets/img/products/bebidas quentes/Café.png'
        }
        if(item.id === '5'){
          return '/assets/img/products/bebidas quentes/chinesa.png'
        }
        if(item.id === '2'){
          return '/assets/img/products/bebidas quentes/galão.png'
        }
        if(item.id === '7' || (item.id >= '54' && item.id <= '59')){
          return '/assets/img/products/bebidas quentes/Chá.png'
        }
        if(item.id === '60'){
          return '/assets/img/products/bebidas quentes/chocolate quente.png'
        }
      }
      if(this.category['category'].title === "Bebidas Frias"){
          if(item.id === '9'){
            return '/assets/img/products/bebidas frias/atlantida_semgas_22_final.jpg'
          }
          if(item.id === '10'){
            return '/assets/img/products/bebidas frias/Coral_PuroMalte 2019.jpg'
          }
          if(item.id === '11'){
            return '/assets/img/products/bebidas frias/Coral_STOUT 20cl_2022.jpg'
          }
          if(item.id === '15'){
            return '/assets/img/products/bebidas frias/ucal.png'
          }
          if(item.id === '16'){
            return '/assets/img/products/bebidas frias/brisa-maca-0_36Lt-800x800-1.jpg'
          }
          if(item.id === '17'){
            return '/assets/img/products/bebidas frias/Brisa Maracuja_36CL 2017.jpg'
          }
          if(item.id === '19'){
            return '/assets/img/products/bebidas frias/compal manga cenoura laranja.png'
          }
          if(item.id === '20'){
            return '/assets/img/products/bebidas frias/compal pessego.png'
          }
          if(item.id === '21'){
            return '/assets/img/products/bebidas frias/compal laranja.png'
          }
          if(item.id === '23'){
            return '/assets/img/products/bebidas frias/compal maracuja.png'
          }
          if(item.id === '45'){
            return '/assets/img/products/bebidas frias/cerveja pressão.png'
          }
          if(item.id === '48'){
            return '/assets/img/products/bebidas frias/Laranjada 33cl.jpg'
          }
          if(item.id === '49'){
            return '/assets/img/products/bebidas frias/Brisa-Maracuja-sem-acucar-036.jpg'
          }
          if(item.id === '50'){
            return '/assets/img/products/bebidas frias/compal pera.png'
          }
          if(item.id === '51'){
            return '/assets/img/products/bebidas frias/c.-frutos-vermelhos-0.2l.png'
          }
          if(item.id === '52'){
            return '/assets/img/products/bebidas frias/Atlantida 50 cl_blue .jpg'
          }
          if(item.id === '53'){
            return '/assets/img/products/bebidas frias/atlantida_gas_22_final.jpg'
          }
          if(item.id === '61'){
            return '/assets/img/products/bebidas frias/fuze-tea-limao-vidro-300ml-produto.jpg'
          }
          if(item.id === '62'){
            return '/assets/img/products/bebidas frias/fuze-tea-pessego-vidro-300ml-produto.jpg'
          }
          if(item.id === '63'){
            return '/assets/img/products/bebidas frias/fuze-tea-manga-ananas-vidro-300ml-produto.jpg'
          }
          if(item.id === '65'){
            return '/assets/img/products/bebidas frias/coca-cola-original-vidro-350ml-gotas.png'
          }
          if(item.id === '68'){
            return '/assets/img/products/bebidas frias/coca-cola-zero-acucar-vidro-350ml-gotas.png'
          }
          if(item.id === '69'){
            return '/assets/img/products/bebidas frias/fanta-laranja-vidro-350ml.png'
          }
          if(item.id === '70'){
            return '/assets/img/products/bebidas frias/fanta-ananas-vidro-350ml-gotas.png'
          }
          if(item.id === '97'){
            return '/assets/img/products/bebidas frias/monster.jpg'
          }
          if(item.id === '99'){
            return '/assets/img/products/bebidas frias/bandida maça.png'
          }
          if(item.id === '100'){
            return '/assets/img/products/bebidas frias/água com limão - castello.png'
          }
          if(item.id === '101'){
            return '/assets/img/products/bebidas frias/sprite-vidro-350ml-gotas.png'
          }
          if(item.id === '102'){
            return '/assets/img/products/bebidas frias/coca-cola-zero-baunilha-lata-sleek-330ml-gotas.png'
          }
          if(item.id === '103'){
            return '/assets/img/products/bebidas frias/monster_energy_ultra-350x350.png'
          }
          if(item.id === '106'){
            return 
          }
      }
      if(this.category['category'].title === "Gelados"){
        if(item.id === '112'){
          return '/assets/img/products/gelados/calipo limão.png'
        }
        if(item.id === '113'){
          return '/assets/img/products/gelados/perna de pau.png'
        }
        if(item.id === '114'){
          return '/assets/img/products/gelados/solero exotic.jpg'
        }
        if(item.id === '115'){
          return '/assets/img/products/gelados/cornetto filipino.png'
        }
        if(item.id === '116'){
          return '/assets/img/products/gelados/CORNETTO-CLASSIC-VANILLA-600x600.png'
        }
        if(item.id === '117'){
          return '/assets/img/products/gelados/cornetto morango.png'
        }
        if(item.id === '118'){
          return '/assets/img/products/gelados/filipinos sandwich.png'
        }
        if(item.id === '119'){
          return '/assets/img/products/gelados/magnum sandwich.jpg'
        }
        if(item.id === '120'){
          return '/assets/img/products/gelados/Magnum Double Gold billionaire.jpg'
        }
        if(item.id === '121'){
          return '/assets/img/products/gelados/Magnum chocolate branco.png'
        }
        if(item.id === '122'){
          return '/assets/img/products/gelados/Magnum de amêndoas.png'
        }
        if(item.id === '124'){
          return '/assets/img/products/gelados/Calippo de morango.jpg'
        }
      }
      if(this.category['category'].title === "Pizzas"){
        if(item.id === "131"){
          return '/assets/img/products/pizzas/pizza romana.jpg'
        }
        if(item.id === "132"){
          return '/assets/img/products/pizzas/pizza pepperoni.jpg'
        }
        if(item.id === "133"){
          return '/assets/img/products/pizzas/pizza margerita.png'
        }
      }
      return item.image;
    }
  },

  computed: {
    filteredProducts() {
      return this.category['products'].filter(product => (product.title.toLowerCase().includes(this.search.toLowerCase())));
    },
    ...mapGetters(['getItemQuantity']),
    itemQuantity() {
      return (id) => this.getItemQuantity(this.category['products'].find(i => i.id === id));
    },
  },

  mounted() {
    document.getElementById('searchForm').addEventListener('keypress', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
  },
};

</script>

<style>

.opacElement {
  opacity: 0.3 !important;
  pointer-events: none !important;
}

.product-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 8px; 
}

/*Retirar borda verde*/
/*.wishlist-bx,
.wishlist-bx .card-overlay.style-1.bg-primary,
.card-overlay.style-1.bg-primary {
  border: none !important;    
  outline: none !important;
}*/
</style>

